import styled from '@emotion/styled';
import { NextRouter, useRouter } from 'next/router';
import { controller } from 'src/switch-themes';
import { splitRote } from 'src/utils/helper';

const { image } = controller;

const WidgetEmpty = () => {
  const router: NextRouter = useRouter();

  return (
    <WidgetWrapper className='no-article'>
      <img src={image?.noArticle || `${splitRote(router)}/static/images/logo.png`} title='no-article' alt='no-article' width='100%' height='100%' loading='lazy' />
    </WidgetWrapper>
  );
};

export default WidgetEmpty;

const WidgetWrapper = styled.div`
  display: block;
  max-width: 70%;
  margin: auto;
  img {
    opacity: 0.6;
  }
  @media (max-width: 767px) {
    max-width: 100%;
  }
`;
